import React, { useState } from 'react';
import Card from './component/card/Card'



export default function App() {
 
 
  return (
    <>
     <Card/>
    </>
  );
}

 
